<script>
import { hasKnownContactName } from 'dashboard/helper/phoneHelper';

export default {
  name: 'CallerInfo',
  computed: {
    contact() {
      return this.$store.state.phone.contact;
    },
    callerId() {
      return this.$store.state.phone.callerId;
    },
    phoneNumber() {
      return this.$store.state.phone.otherPartyNumber;
    },
    contactUrl() {
      if (!this.contact) return null;
      const accountId = this.$store.getters.getCurrentAccountId;
      return `/app/accounts/${accountId}/contacts/${this.contact.id}`;
    },
    existingContact() {
      return hasKnownContactName(this.contact?.name, this.phoneNumber);
    },
  },
};
</script>

<template>
  <div class="caller-info-wrapper">
    <router-link v-if="existingContact" :to="contactUrl" class="contact-link">
      {{ contact.name }}
    </router-link>
    <div v-else-if="callerId" class="caller-id">{{ callerId }}</div>
    <div v-else class="phone-number">{{ phoneNumber }}</div>

    <template v-if="existingContact">
      <div v-if="callerId">{{ callerId }}</div>
      <div v-else>{{ phoneNumber }}</div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.caller-info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
}

.contact-link {
  font-weight: 600;
  color: #1f93ff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.dark .contact-link {
  color: #58a6ff;
}
</style>
